import React, { useState } from "react";

const MockTicketSidePanel = ({ tickets, currentId, onSelect }) => {
    const [query, setQuery] = useState("");
    const filtered = tickets.filter((t) => {
        if (!query.trim()) return true;
        const q = query.toLowerCase();
        return t.title.toLowerCase().includes(q) || t.preview.toLowerCase().includes(q);
    });

    return (
        <aside className="clk-mk-ticket-panel">
            <div className="clk-mk-ticket-panel-head">
                <input
                    type="search"
                    className="clk-mk-ticket-panel-search"
                    placeholder="Search tickets…"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    aria-label="Search tickets in panel"
                />
            </div>
            <ul className="clk-mk-ticket-panel-list">
                {filtered.map((t) => (
                    <li key={t.id}>
                        <button
                            type="button"
                            className={String(t.id) === String(currentId) ? "is-active" : ""}
                            onClick={() => onSelect(t)}
                        >
                            <strong>{t.title}</strong>
                            <span>{t.preview}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default MockTicketSidePanel;
